// Identite textuelle de la marque (nom, accroche, description). Un client = on remplace ce
// fichier avec le reste de src/branding/ (cf. BRANDING.md). Les variables de build
// VITE_BRANDING_NAME / VITE_BRANDING_TAGLINE surchargent ces valeurs (instance Demo habillee
// aux couleurs d'un prospect, D-DEMO-01) ; sans variable, ce sont ces valeurs qui s'appliquent.
export const BRAND_DEFAULT = {
  name: 'SERME',
  tagline: 'Traçabilité de vos déchets, du chantier au centre de traitement.',
} as const;
